import * as React from 'react';

import { Body } from '@swyftx/aviary/atoms/Typography';
import { EnhancedTooltip } from '@swyftx/aviary/molecules/EnhancedTooltip/EnhancedTooltip';

type Props = {
  title: string;
  tooltip?: string;
};

const CustomTooltip: React.FC<Props> = ({ title, tooltip }) => (
  <EnhancedTooltip title={tooltip} name={title} align='start' side='top'>
    <Body underline='dashed' color='secondary' className='w-fit decoration-color-border-neutral' size='medium'>
      {title}
    </Body>
  </EnhancedTooltip>
);

CustomTooltip.displayName = 'SingleLoanHealthCard';

export { CustomTooltip };
